// Record History

//This is a simple table making controller with some options.
//In most cases we're trying to send back rows and columns with simple table key values, however...
//For KeyValue pair, you need simply only set type=text and the dbkey of the table.
//For DateTimes we'd like formatting, so you can send in type=friendlydate and it will format the value for you (provided you converted it correctly in PHP on fetch)
//For Users, we give the relationship (updateuser, deleteuser, creationuser, etc). type=updateuser typically.

import React from 'react';

//Datetime formatting
import Moment from 'react-moment';

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';

const RecordHistory = (props) => {
	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	let recordhistory = props.recordhistory;
	let columns = props.columns;
	let historytitle = props.historytitle;


	return (
		<React.Fragment>
			{(recordhistory) &&
				<>
					<div className={classes.itemtableheader}>{historytitle}</div>
					<div style={{ padding: "0px", width: "100%" }}>
						<table className={classes.flexitemsimpletable} style={{ textAlign: "left" }}>
							<thead>
								<tr>
									{columns.map((column, columnindex) => (
										<td key={"column" + columnindex} style={column.style}>
											{column.columnname}
											</td>
									))}
								</tr>
							</thead>
							<tbody>
								{recordhistory.map((historyitem, itemindex) => (
									<tr key={"rowindex"+itemindex}>
										{columns.map((column, columnvalueindex) => (
											<td key={"columnvalues" + columnvalueindex} style={column.style}>
												{(column.type === "friendlydate") &&
													<Moment element='span' format="MMMM D, YYYY [at] h:mma">{historyitem[column.dbkey]}</Moment>
												}
												{(column.type === "text") &&
													<>
														{historyitem[column.dbkey]}
													</>
												}
												{(column.type === "user") &&
													<>	{/* In some cases, old tables don't even have updateuser for given records so this relationship might be null */}

														{historyitem.updateuser? historyitem[column.dbkey].firstname+ " " + historyitem[column.dbkey].lastname : ""}
													</>
												}
											</td>
										))}
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</>
			}


		</React.Fragment>

	)
}


export default RecordHistory;